import {
    useEffect,
    useState,
} from "react";

import CrudModal from "components/crud/CrudModal";
import CrudInput from "components/crud/CrudInput";
import CrudSelect from "components/crud/CrudSelect";

import {
    createSampleIssue,
    updateSampleIssue,
} from "services/api/sampleTrackingApi";

import {
    getSchools,
} from "services/api/schoolApi";

import {
    getBooks,
} from "services/api/bookApi";

import {
    showSuccess,
    showError,
} from "utils/toast";


const DEFAULT_FORM = {
    schoolId: "",
    bookId: "",
    visitId: "",
    quantity: 1,
    issueDate: "",
    remarks: "",
};


export default function SampleIssueModal({
    open,
    onClose,
    reload,
    item,
}) {

    const isEdit =
        Boolean(item);


    // =========================================================
    // LOADING
    // =========================================================

    const [
        loading,
        setLoading,
    ] = useState(false);


    const [
        schoolsLoading,
        setSchoolsLoading,
    ] = useState(false);


    const [
        booksLoading,
        setBooksLoading,
    ] = useState(false);


    // =========================================================
    // DATA
    // =========================================================

    const [
        schools,
        setSchools,
    ] = useState([]);


    const [
        books,
        setBooks,
    ] = useState([]);


    // =========================================================
    // FORM
    // =========================================================

    const [
        form,
        setForm,
    ] = useState(
        DEFAULT_FORM
    );


    // =========================================================
    // LOAD SCHOOLS
    // =========================================================

    const loadSchools =
        async () => {

            try {

                setSchoolsLoading(
                    true
                );


                const response =
                    await getSchools(
                        1,
                        500
                    );


                const data =
                    response?.data?.schools ||
                    response?.data?.data?.schools ||
                    response?.data?.records ||
                    response?.data?.data?.records ||
                    [];


                setSchools(
                    Array.isArray(data)
                        ? data
                        : []
                );

            } catch (
                error
            ) {

                console.error(
                    "Schools loading error:",
                    error
                );


                setSchools(
                    []
                );


                showError(
                    error?.response?.data?.message ||
                    "Unable to load schools."
                );

            } finally {

                setSchoolsLoading(
                    false
                );

            }

        };


    // =========================================================
    // LOAD BOOKS
    // =========================================================

    const loadBooks =
        async () => {

            try {

                setBooksLoading(
                    true
                );


                const response =
                    await getBooks(
                        1,
                        500,
                        "",
                        "active"
                    );


                console.log(
                    "BOOKS RESPONSE:",
                    response
                );


                const data =
                    response?.data?.books ||
                    response?.data?.data?.books ||
                    response?.books ||
                    [];


                setBooks(
                    Array.isArray(data)
                        ? data
                        : []
                );

            } catch (
                error
            ) {

                console.error(
                    "Books loading error:",
                    error
                );


                setBooks(
                    []
                );


                showError(
                    error?.response?.data?.message ||
                    "Unable to load books."
                );

            } finally {

                setBooksLoading(
                    false
                );

            }

        };


    // =========================================================
    // INITIALIZE MODAL
    // =========================================================

    useEffect(
        () => {

            if (!open) {
                return;
            }


            /*
            |--------------------------------------------------------------------------
            | Load dropdown data
            |--------------------------------------------------------------------------
            */

            loadSchools();
            loadBooks();


            /*
            |--------------------------------------------------------------------------
            | Edit
            |--------------------------------------------------------------------------
            */

            if (item) {

                setForm({

                    schoolId:
                        item?.school?.id ||
                        item?.schoolId ||
                        "",

                    bookId:
                        item?.book?.id ||
                        item?.bookId ||
                        "",

                    visitId:
                        item?.visit?.id ||
                        item?.visitId ||
                        "",

                    quantity:
                        item?.quantity ||
                        1,

                    issueDate:
                        item?.issueDate
                            ? String(
                                item.issueDate
                            ).substring(
                                0,
                                10
                            )
                            : "",

                    remarks:
                        item?.remarks ||
                        "",

                });

            } else {

                /*
                |--------------------------------------------------------------------------
                | Create
                |--------------------------------------------------------------------------
                */

                setForm({

                    ...DEFAULT_FORM,

                    issueDate:
                        new Date()
                            .toISOString()
                            .substring(
                                0,
                                10
                            ),

                });

            }

        },
        [
            open,
            item,
        ]
    );


    // =========================================================
    // CHANGE
    // =========================================================

    const handleChange =
        (e) => {

            const {
                name,
                value,
            } = e.target;


            setForm(
                (prev) => ({

                    ...prev,

                    [name]:
                        value,

                })
            );

        };


    // =========================================================
    // SUBMIT
    // =========================================================

    const handleSubmit =
        async (e) => {

            e.preventDefault();


            // -------------------------------------------------
            // SCHOOL
            // -------------------------------------------------

            if (
                !form.schoolId
            ) {

                showError(
                    "Please select a school."
                );

                return;

            }


            // -------------------------------------------------
            // BOOK
            // -------------------------------------------------

            if (
                !form.bookId
            ) {

                showError(
                    "Please select a book."
                );

                return;

            }


            // -------------------------------------------------
            // QUANTITY
            // -------------------------------------------------

            if (
                Number(
                    form.quantity
                ) < 1
            ) {

                showError(
                    "Quantity must be at least 1."
                );

                return;

            }


            // -------------------------------------------------
            // DATE
            // -------------------------------------------------

            if (
                !form.issueDate
            ) {

                showError(
                    "Please select issue date."
                );

                return;

            }


            try {

                setLoading(
                    true
                );


                const payload = {

                    schoolId:
                        String(
                            form.schoolId
                        ),

                    bookId:
                        String(
                            form.bookId
                        ),

                    visitId:
                        form.visitId
                            ? String(
                                form.visitId
                            )
                            : undefined,

                    quantity:
                        Number(
                            form.quantity
                        ),

                    issueDate:
                        form.issueDate,

                    remarks:
                        form.remarks?.trim() ||
                        undefined,

                };


                console.log(
                    "SAMPLE ISSUE PAYLOAD:",
                    payload
                );


                // -------------------------------------------------
                // UPDATE
                // -------------------------------------------------

                if (isEdit) {

                    await updateSampleIssue(
                        item.id,
                        payload
                    );


                    showSuccess(
                        "Sample issue updated successfully."
                    );

                }

                // -------------------------------------------------
                // CREATE
                // -------------------------------------------------

                else {

                    await createSampleIssue(
                        payload
                    );


                    showSuccess(
                        "Sample issue created successfully."
                    );

                }


                await reload();

                onClose();

            } catch (
                error
            ) {

                console.error(
                    "Sample issue save error:",
                    error
                );


                const message =
                    error?.response?.data?.message;


                if (
                    Array.isArray(
                        message
                    )
                ) {

                    showError(
                        message.join(
                            ", "
                        )
                    );

                } else {

                    showError(
                        message ||
                        "Unable to save sample issue."
                    );

                }

            } finally {

                setLoading(
                    false
                );

            }

        };


    // =========================================================
    // SCHOOL OPTIONS
    // =========================================================

    const schoolOptions = [

        {
            value: "",

            label:
                schoolsLoading
                    ? "Loading Schools..."
                    : "Select School",
        },

        ...schools.map(
            (school) => ({

                value:
                    String(
                        school.id
                    ),

                label:
                    school.name ||
                    school.schoolName ||
                    school.schoolCode ||
                    `School ${school.id}`,

            })
        ),

    ];


    // =========================================================
    // BOOK OPTIONS
    // =========================================================

    const bookOptions = [

        {
            value: "",

            label:
                booksLoading
                    ? "Loading Books..."
                    : "Select Book",
        },

        ...books.map(
            (book) => ({

                value:
                    String(
                        book.id
                    ),

                label:
                    book.isbn
                        ? `${book.title} (${book.isbn})`
                        : book.title,

            })
        ),

    ];


    // =========================================================
    // CLOSE
    // =========================================================

    if (!open) {
        return null;
    }


    // =========================================================
    // RENDER
    // =========================================================

    return (

        <CrudModal

            open={
                open
            }

            title={
                isEdit
                    ? "Edit Sample Issue"
                    : "Issue Sample"
            }

            loading={
                loading
            }

            submitText={
                isEdit
                    ? "Update"
                    : "Issue Sample"
            }

            onClose={
                onClose
            }

            onSubmit={
                handleSubmit
            }

            width="max-w-3xl"

        >

            {/* =================================================
                MAIN FORM
            ================================================= */}

            <div
                className="
                    grid
                    grid-cols-1
                    gap-5
                    md:grid-cols-2
                "
            >

                {/* SCHOOL */}

                <CrudSelect
                    label="School"
                    name="schoolId"
                    value={
                        form.schoolId
                    }
                    onChange={
                        handleChange
                    }
                    options={
                        schoolOptions
                    }
                />


                {/* BOOK */}

                <CrudSelect
                    label="Book"
                    name="bookId"
                    value={
                        form.bookId
                    }
                    onChange={
                        handleChange
                    }
                    options={
                        bookOptions
                    }
                />


                {/* QUANTITY */}

                <CrudInput
                    label="Quantity"
                    type="number"
                    min="1"
                    name="quantity"
                    value={
                        form.quantity
                    }
                    onChange={
                        handleChange
                    }
                />


                {/* ISSUE DATE */}

                <CrudInput
                    label="Issue Date"
                    type="date"
                    name="issueDate"
                    value={
                        form.issueDate
                    }
                    onChange={
                        handleChange
                    }
                />

            </div>


            {/* =================================================
                VISIT
            ================================================= */}

            <div
                className="
                    mt-5
                "
            >

                <CrudInput
                    label="Visit ID (Optional)"
                    name="visitId"
                    value={
                        form.visitId
                    }
                    onChange={
                        handleChange
                    }
                    placeholder="Optional visit ID"
                />

            </div>


            {/* =================================================
                REMARKS
            ================================================= */}

            <div
                className="
                    mt-5
                "
            >

                <CrudInput
                    label="Remarks"
                    name="remarks"
                    value={
                        form.remarks
                    }
                    onChange={
                        handleChange
                    }
                    placeholder="
                        Sample issue remarks
                    "
                />

            </div>


            {/* =================================================
                LOADING INFO
            ================================================= */}

            {
                (
                    schoolsLoading ||
                    booksLoading
                ) && (

                    <div
                        className="
                            mt-5
                            rounded-xl
                            bg-blue-50
                            px-4
                            py-3
                            text-sm
                            text-blue-700
                        "
                    >

                        {schoolsLoading &&
                            booksLoading &&
                            "Loading schools and books..."}

                        {schoolsLoading &&
                            !booksLoading &&
                            "Loading schools..."}

                        {!schoolsLoading &&
                            booksLoading &&
                            "Loading books..."}

                    </div>

                )
            }


            {/* =================================================
                BOOK COUNT
            ================================================= */}

            {
                !booksLoading &&
                books.length === 0 && (

                    <div
                        className="
                            mt-5
                            rounded-xl
                            border
                            border-yellow-200
                            bg-yellow-50
                            px-4
                            py-3
                            text-sm
                            text-yellow-700
                        "
                    >
                        No active books found.
                        Please create an active book
                        from the Books module first.
                    </div>

                )
            }

        </CrudModal>

    );

}